
    var riot = require('riot')
    //src: starling/src/tags/link-handles.html
riot.tag2('link-handles',
  '<div ref="fromHandle" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" data-direction="from" class="link-handle" title="Drag to move relationship"></div> <div ref="toHandle" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" data-direction="to" class="link-handle" title="Drag to move relationship"></div>',
  '',
  'ref="main"', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _nodesUi = require('lib/nodes-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.linkHandlesTag = this;

this.hovered = false;

this.on('mount', function () {
  _this.registerHandles();
});

this.summon = function (link) {
  if (canvas.isViewOnly()) return;
  _this.link = link;
  _this.position();
  _this.refs.main.classList.add('active');
};

this.hide = function () {
  if (_this.hovered) return;
  if (_this.link) {
    var linkId = _this.link.id;
    _this.link = null;
    canvas.linkTags[linkId].update();
  }
  _this.refs.main.classList.remove('active');
};

this.position = function () {
  var link = _this.link;

  if (!link) return;

  var _refs = _this.refs,
      fromHandle = _refs.fromHandle,
      toHandle = _refs.toHandle;

  var linkTag = canvas.linkTags[link.id];

  var _ref = linkTag.describedArc || linkTag.describeArc(),
      fromPoint = _ref.fromPoint,
      toPoint = _ref.toPoint,
      path = _ref.path;

  var fromX = void 0,
      fromY = 0;
  var toX = void 0,
      toY = 0;

  if (link.lineCurvature === 'elbow') {
    var points = path.split(' L ');

    var _points$0$replace$spl = points[0].replace('M', '').split(' ');

    fromX = _points$0$replace$spl[0];
    fromY = _points$0$replace$spl[1];

    var _points$split = points[points.length - 1].split(' ');

    toX = _points$split[0];
    toY = _points$split[1];
  } else if (fromPoint && toPoint) {
    fromX = fromPoint.x;
    fromY = fromPoint.y;

    toX = toPoint.x;
    toY = toPoint.y;
  }

  Object.assign(fromHandle.style, { left: fromX + 'px', top: fromY + 'px' });
  Object.assign(toHandle.style, { left: toX + 'px', top: toY + 'px' });
};

this.handleMouseEnter = function (e) {
  if (_this.link) {
    var linkTag = canvas.linkTags[_this.link.id];
    linkTag.endpointHovered = true;
    linkTag.unsetMouseLeaveTimeout();
    linkTag.setHoveredState();
    linkTag.shiftEnds();
  }

  _this.hovered = true;
};

this.handleMouseLeave = function (e) {
  _this.hovered = false;
  if (_this.link) {
    var linkTag = canvas.linkTags[_this.link.id];
    linkTag.endpointHovered = false;
    linkTag.triggerDelayedMouseLeave();
  }
};

this.registerHandles = function () {

  var direction = null;
  var fixedNode = null;

  (0, _interactjs2.default)(_this.refs.main).draggable({
    onstart: function onstart(e) {
      if (canvas.isViewOnly()) return;
      var link = _this.link;
      direction = e.interaction.downEvent.target.getAttribute('data-direction');
      fixedNode = direction == 'from' ? link.toNode() : link.fromNode();
      canvas.setLinkDragging(link.id);
      canvas.linkMenuTag.hide();

      /* if link isn't selected, select it */
      if (_this.link && !canvas.isSelectedElement(_this.link.id)) {
        var linkTag = canvas.linkTags[_this.link.id];
        linkTag.clearHoverState();
        canvas.toggleSelectedElement(linkTag, false);
      }
    },

    onmove: function onmove(e) {
      if (canvas.isViewOnly()) return;
      _this.refs.main.classList.add('dragging');
      var link = _this.link;

      var _canvas$getMatrix = canvas.getMatrix(),
          scale = _canvas$getMatrix.scale,
          tx = _canvas$getMatrix.tx,
          ty = _canvas$getMatrix.ty;

      var prop = direction == 'from' ? '_overrideFromPoint' : '_overrideToPoint';
      link[prop] = {
        x: (e.clientX - tx) / scale,
        y: (e.clientY - ty) / scale
      };

      canvas.nodeTags[fixedNode.id].placeLinkNodesRecursively(fixedNode);
      canvas.linkTags[link.id].updatePosition();
      canvas.tags['link-handles'].position();

      var targetNodeTag = canvas.mouseEnteredNode;

      if (targetNodeTag) {
        var toNodeId = link.toNodeId;
        var fromNodeId = link.fromNodeId;
        var node = direction == 'from' ? link.fromNode() : link.toNode();
        var targetNode = store.getNode(targetNodeTag.id);

        if (link.fromNodeId == node.id) {
          fromNodeId = targetNodeTag.id;
        } else {
          toNodeId = targetNodeTag.id;
        }

        var valid = store._validateLinkedNodes(fromNodeId, toNodeId, link.linkNodeId) && (!link.linkNode() || !_nodesUi.nui.computeMovingParts(store, link.linkNode()).targetNodeIds.includes(targetNode.id));
        if (!valid) {
          targetNodeTag.refs.container.classList.add('link-dragging-no-highlight');
        }
      }
    },

    onend: function onend(e) {
      if (canvas.isViewOnly()) return;
      var link = _this.link;
      if (!link) return;
      link._overrideFromPoint = null;
      link._overrideToPoint = null;

      var targetNodeTag = canvas.mouseEnteredNode;
      var prevToNodeId = link.toNodeId;
      var prevFromNodeId = link.fromNodeId;

      var initNodeIds = [link.fromNodeId, link.toNodeId];

      $('.link-dragging-no-highlight').removeClass('link-dragging-no-highlight');

      var summonFloatingTool = false;
      var newEndPoints = false;
      if (targetNodeTag) {

        var toNodeId = link.toNodeId;
        var fromNodeId = link.fromNodeId;
        var node = direction == 'from' ? link.fromNode() : link.toNode();
        var targetNode = store.getNode(targetNodeTag.id);

        if (link.fromNodeId == node.id) {
          fromNodeId = targetNodeTag.id;
        } else {
          toNodeId = targetNodeTag.id;
        }

        var valid = store._validateLinkedNodes(fromNodeId, toNodeId, link.linkNodeId) && (!link.linkNode() || !_nodesUi.nui.computeMovingParts(store, link.linkNode()).targetNodeIds.includes(targetNode.id));

        if (valid) {
          newEndPoints = true;
          link.setEndpoints({ fromNodeId: fromNodeId, toNodeId: toNodeId });
        }
      } else {
        summonFloatingTool = true;
      }

      canvas.setLinkDragging(false);
      canvas.tags['link-handles'].position();
      _this.refs.main.classList.remove('dragging');
      canvas.linkTags[link.id].updatePosition();
      canvas.nodeTags[fixedNode.id].placeLinkNodesRecursively(fixedNode);

      if (newEndPoints) {
        canvas.operation.setLinkEndpoints({
          linkUUID: link.id,
          fromNodeId: link.fromNodeId,
          toNodeId: link.toNodeId,
          prevFromNodeId: prevFromNodeId,
          prevToNodeId: prevToNodeId,
          onFailure: function onFailure(err) {
            console.log('setLinkEndpoints failure: ' + err);
          }
        });
      }

      if (summonFloatingTool) {
        var fromNode = direction == 'from' ? canvas.nodeTags[link.toNodeId] : canvas.nodeTags[link.fromNodeId];

        canvas.floatingRLineTag.summon({
          fromNode: fromNode,
          toPos: { left: e.clientX, top: e.clientY }
        });

        canvas.store.deleteLink(link.id);
        canvas.linksTag.update();
        canvas.operation.deleteLink({
          linkId: link.id
        });
      }
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('link-handles')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/link-handles.html
// module id = 641
// module chunks = 0